import { all, call, put, spawn } from 'redux-saga/effects';
import addToTakeShape from './add-to-takeshape/saga';
import { agentEditorSaga } from './agent/slice';
import { aiEditorSaga } from './ai/slice';
import apiExplorer from './api-explorer/saga';
import apiKeys from './api-keys/saga';
import assetPicker from './asset-picker/saga';
import assetUploader from './asset-uploader/saga';
import assets from './assets/saga';
import auth from './auth/saga';
import branches from './branches/saga';
import collab from './collab/saga';
import { context } from './config';
import confirm from './confirm/saga';
import content from './content/saga';
import contentList from './content-list/saga';
import { saga as contentPreview } from './content-preview';
import contentSearch from './content-search/saga';
import exportProject from './export/saga';
import formDialog from './form-dialog/saga';
import integrations from './integrations/saga';
import { saga as liveLinks } from './live-links';
import locales from './locales/saga';
import { showMessage } from './messages/actions';
import message from './messages/saga';
import { saga as netlifyAddon } from './netlify-addon';
import project from './project/saga';
import schedule from './schedule/saga';
import { schemaSaga as schema } from './schema';
import schemaForm from './schema-form/saga';
import service from './services/saga';
import staticSite from './sites/saga';
import sso from './sso/saga';
import userRole from './user-roles/saga';
import userTracking from './user-tracking/saga';
import version from './versions/saga';
import webhooks from './webhooks/saga';
import workbench from './workbench/saga';
import workflows from './workflows/saga';

export default function* root() {
  const sagas = {
    auth,
    collab,
    assets,
    assetUploader,
    project,
    schema,
    contentList,
    content,
    contentSearch,
    schemaForm,
    confirm,
    formDialog,
    staticSite,
    message,
    apiKeys,
    assetPicker,
    userTracking,
    webhooks,
    integrations,
    locales,
    liveLinks,
    netlifyAddon,
    service,
    version,
    userRole,
    workflows,
    schedule,
    sso,
    contentPreview,
    addToTakeShape,
    exportProject,
    apiExplorer,
    workbench,
    branches,
    agentEditorSaga,
    aiEditorSaga
  };

  yield all(
    Object.entries(sagas).map(([name, saga]) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (error) {
            if (context.tier === 'dev') {
              const message = `Uncaught Error in "${name}" Saga`;

              console.trace(message, error);
              yield put(showMessage('error', `${message}: "${error.message}" See console for more information.`));
            }
          }
        }
      })
    )
  );
}
